module.exports = __webpack_public_path__ + "img/cannon-speed.8a1341de.png";